import { GoalPayload } from '_api/types';
import { GOALTYPECONSTANTS } from '_constants/derived';

const DefaultNewGoal: GoalPayload = {
  goalType: GOALTYPECONSTANTS.SHORT,
  title: '',
  description: '',
  status: 'PROGRESS',
  patientId: 0,
};

export default DefaultNewGoal;
